import BaseComponent from '@/components/base';
import { Style } from '@/components/alert-modal/style';
import { FontStyle } from '@/components/style';

export default class AlertModal extends BaseComponent {
  static get observedAttributes() {
    return [
      'title',
      'description',
      'enabled',
      'image-success-src',
      'image-error-src',
      'type'
    ];
  }

  afterMount() {
    this.shadowRoot.querySelector('modal-component').onChangeEnabled = (
      value
    ) => {
      this.enabled = value;
    };
  }

  get imageSuccessSrc() {
    return this.getAttribute('image-success-src');
  }

  get imageErrorSrc() {
    return this.getAttribute('image-error-src');
  }

  get type() {
    return this.getAttribute('type');
  }

  set type(value) {
    this.setAttribute('type', value);
  }

  get title() {
    return this.getAttribute('title');
  }

  set title(value) {
    this.setAttribute('title', value);
  }

  get description() {
    return this.getAttribute('description');
  }

  set description(value) {
    this.setAttribute('description', value);
  }

  get width() {
    return this.getAttribute('width');
  }

  get enabled() {
    return this.getAttribute('enabled') === 'true';
  }

  set enabled(value) {
    this.setAttribute('enabled', `${value}`);
  }

  render() {
    return `
      ${FontStyle}
      ${Style}
      <modal-component
        modal-width="${this.width ?? '600px'}"
        header-disabled="false"
        transparent="false"
        enabled="${this.enabled}"
        light-bg="1"
        class="alert-modal"
      >
        <div class="modal-wrapper">
          <img class="modal-image" src="${
            this.type == 'success' ? this.imageSuccessSrc : this.imageErrorSrc
          }">
          <h3 class="modal-title">${this.title}</h3>
          <p class="modal-description">${this.description}</p>
        </div>
      </modal-component>
    `;
  }
}
